import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield, AlertTriangle, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsAndConditions: React.FC = () => {
    // Scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-gray-900 pt-24 pb-12 px-4">
            <div className="container mx-auto max-w-4xl">
                <Link
                    to="/"
                    className="inline-flex items-center text-primary-400 hover:text-primary-300 mb-8 transition-colors"
                >
                    <ArrowLeft className="w-5 h-5 mr-2" />
                    Atgriezties uz sākumu
                </Link>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm"
                >
                    <h1 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-300 via-primary-100 to-accent-200 mb-8">
                        Noteikumi un Nosacījumi
                    </h1>

                    <div className="space-y-8 text-gray-300 leading-relaxed">
                        <section>
                            <h2 className="text-xl font-bold text-white mb-4 flex items-center">
                                <Shield className="w-6 h-6 text-primary-400 mr-3" />
                                1. Vispārīgie noteikumi
                            </h2>
                            <p className="mb-4">
                                Piesakoties "SuperDiena" pasākumam, dalībnieks (vai viņa likumiskais pārstāvis, ja dalībnieks ir nepilngadīgs) apliecina, ka ir iepazinies ar šiem noteikumiem un piekrīt tiem.
                            </p>
                            <p>
                                Pasākuma organizatori patur tiesības veikt izmaiņas pasākuma programmā, iepriekš par to nebrīdinot, ja tas nepieciešams drošības vai citu neparedzētu apstākļu dēļ.
                            </p>
                        </section>

                        <section className="bg-red-900/10 border border-red-500/20 rounded-xl p-6">
                            <h2 className="text-xl font-bold text-red-300 mb-4 flex items-center">
                                <AlertTriangle className="w-6 h-6 text-red-400 mr-3" />
                                2. Atbildības ierobežojumi
                            </h2>
                            <div className="space-y-4">
                                <p>
                                    <strong className="text-white">Dalība uz savu atbildību:</strong> Visi dalībnieki piedalās pasākumā un tā aktivitātēs pilnībā uz savu risku un atbildību. Apzinoties, ka fiziskas aktivitātes var būt saistītas ar traumu risku, dalībnieks apņemas ievērot piesardzību un organizatoru norādījumus.
                                </p>
                                <p>
                                    <strong className="text-white">Organizatoru atbildība:</strong> "SuperDiena" organizatori un brīvprātīgie neuzņemas nekādu atbildību par dalībnieku personīgajām mantām, veselības stāvokļa pasliktināšanos vai traumām, kas gūtas pasākuma laikā, izņemot gadījumus, kas radušies organizatoru ļaunprātīgas rīcības dēļ.
                                </p>
                                <p>
                                    <strong className="text-white">Nepilngadīgie dalībnieki:</strong> Par nepilngadīgo dalībnieku uzvedību un drošību primāri atbildīgi ir viņu vecāki vai likumiskie aizbildņi. Bērniem līdz 7 gadu vecumam obligāta vecāka vai aizbildņa klātbūtne.
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4 flex items-center">
                                <Mail className="w-6 h-6 text-secondary-400 mr-3" />
                                3. Komunikācija un dati
                            </h2>
                            <p className="mb-4">
                                Norādot savu e-pasta adresi reģistrācijas formā, Jūs piekrītat saņemt:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Informāciju, kas tieši saistīta ar pasākuma norisi (programma, izmaiņas, atgādinājumi).</li>
                                <li>Mārketinga materiālus un informāciju par nākotnes pasākumiem.</li>
                            </ul>
                            <p className="mt-4 text-sm text-gray-400">
                                Jūsu dati netiks nodoti trešajām pusēm, izņemot gadījumus, kad to pieprasa Latvijas Republikas likumdošana vai tas nepieciešams pasākuma medecīniskā nodrošinājuma sniegšanai.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">4. Fotogrāfēšana un filmēšana</h2>
                            <p>
                                Pasākuma laikā var tikt veikta fotogrāfēšana un filmēšana. Iegūtie materiāli var tikt izmantoti pasākuma publicitātes nolūkos sociālajos tīklos un mājaslapā. Ja iebilstat pret savu vai sava bērna fotogrāfēšanu, lūdzu, informējiet organizatorus pirms pasākuma sākuma.
                            </p>
                        </section>

                        <div className="pt-8 border-t border-white/10 mt-8">
                            <p className="text-sm text-gray-400 text-center">
                                Pēdējās izmaiņas: 2025. gada 10. decembris
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
